import { couponApi } from '../app/axios';

export default class CouponService {
  static async getList(orgId) {
    if (!orgId) {
      throw new Error('CouponService.getList: orgId undefined');
    }

    const response = await couponApi.get(`/coupon/api/v1/couponSet/${orgId}`, {
      headers: {
        'x-super8-organization': orgId,
      },
    });

    return response?.data?.couponList || [];
  }
}
